import type { RefObjectForHighchartsReact } from "components/charts/modern/abstract/HighchartsChart";
import type { Series } from "highcharts";
import type { MutableRefObject } from "react";

export default function handleClickInLegend(
  event: Highcharts.SeriesLegendItemClickEventObject,
  serie: Series,
  chartRef: MutableRefObject<RefObjectForHighchartsReact | null>,
) {
  event.preventDefault();

  const legendsEnabled = chartRef?.current?.chart.series.filter((node) => node.visible);

  if (legendsEnabled && legendsEnabled.length === 1 && legendsEnabled[0].name === serie.name) {
    chartRef?.current?.chart.series.forEach((node) => {
      node?.show();
    });
  } else {
    chartRef?.current?.chart.series.forEach((node) => {
      if (node.name === serie.name) {
        node?.show();
      } else {
        node?.hide();
      }
    });
  }

  chartRef?.current?.chart.redraw();
}
